<ion-app>
  <!-- Animated GIF Splash Screen -->
  <app-splash-screen *ngIf="showSplash"></app-splash-screen>
  
  <!-- <app-header></app-header> -->
  <app-side-bar></app-side-bar>
  <ion-router-outlet></ion-router-outlet>
  <app-tab-bar *ngIf="isLoggedIn"></app-tab-bar>
</ion-app>